"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlSelectParse = void 0;
var Sentry = __importStar(require("@sentry/browser"));
var htmlSelectParse = function (_a) {
    var html = _a.html, tag = _a.tag;
    try {
        var regex = new RegExp("<".concat(tag, ".+?>(.*?)</").concat(tag, ">"));
        var match = html.match(regex);
        if (!match)
            return;
        var innerMatch = match[1];
        if (!innerMatch)
            return;
        if (innerMatch === "<br>")
            return;
        if (/^<span/.test(innerMatch))
            return (0, exports.htmlSelectParse)({ html: innerMatch, tag: "span" });
        if (/^<p/.test(innerMatch))
            return (0, exports.htmlSelectParse)({ html: innerMatch, tag: "p" });
        if (/^<div/.test(innerMatch))
            return (0, exports.htmlSelectParse)({ html: innerMatch, tag: "div" });
        return innerMatch;
    }
    catch (error) {
        Sentry.captureException(error, { extra: { html: html, tag: tag } });
        return;
    }
};
exports.htmlSelectParse = htmlSelectParse;
